import { Card, Typography, Button, Space } from 'antd'
import { PlusOutlined, SaveOutlined, PlayCircleOutlined } from '@ant-design/icons'
import { PipelineBuilder } from '@/components/PipelineBuilder'

const { Title, Paragraph, Text: AntText } = Typography

export function PipelinesPage() {
  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <Title level={2} style={{ marginBottom: 8 }}>
          Data Pipelines
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          Build and manage your data transformation pipelines
        </Paragraph>
      </div>

      {/* Action Bar */}
      <Card style={{ marginBottom: 16 }} bodyStyle={{ padding: '16px 24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <AntText strong style={{ fontSize: 16 }}>
              Example Pipeline: Q4 Performance Data Processing
            </AntText>
            <br />
            <AntText type="secondary" style={{ fontSize: 12 }}>
              CSV Upload → Filter Rows → Calculate Metrics → Export JSON
            </AntText>
          </div>
          <Space>
            <Button icon={<SaveOutlined />} size="large">
              Save Pipeline
            </Button>
            <Button type="primary" icon={<PlayCircleOutlined />} size="large">
              Run Pipeline
            </Button>
            <Button icon={<PlusOutlined />} size="large">
              New Pipeline
            </Button>
          </Space>
        </div>
      </Card>

      {/* Pipeline Canvas */}
      <PipelineBuilder />

      {/* Pipeline Info */}
      <Card style={{ marginTop: 16 }} title="Pipeline Steps">
        <Space direction="vertical" style={{ width: '100%' }}>
          <div>
            <AntText strong>1. CSV Upload</AntText>
            <br />
            <AntText type="secondary" style={{ fontSize: 12 }}>
              Source node: Upload CSV file with assessment data
            </AntText>
          </div>
          <div>
            <AntText strong>2. Filter Rows</AntText>
            <br />
            <AntText type="secondary" style={{ fontSize: 12 }}>
              Transformation: Remove incomplete responses (completion &lt; 80%)
            </AntText>
          </div>
          <div>
            <AntText strong>3. Add Calculated Column</AntText>
            <br />
            <AntText type="secondary" style={{ fontSize: 12 }}>
              Transformation: Calculate average score = (Q1 + Q2 + Q3) / 3
            </AntText>
          </div>
          <div>
            <AntText strong>4. Export to JSON</AntText>
            <br />
            <AntText type="secondary" style={{ fontSize: 12 }}>
              Output node: Save processed data as JSON file
            </AntText>
          </div>
        </Space>
      </Card>
    </div>
  )
}

